import {Injectable} from '@angular/core';
import * as Feather from 'feather-icons';

export interface IFeatherIconToSVG {
  class?:string;
  width?:string;
  height?:string;
}

@Injectable({
  providedIn: 'root'
})
export class ConfigureFeatherIconService {
  
  registerIcon(name: string, content: string) {
    //new Feather.Icon(name, content);

    Feather.icons[name] = {
      name: name,
      contents: content,
      tags: ['custom', 'example'],
      toSvg: function (options:IFeatherIconToSVG = {}) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(content, 'image/svg+xml');
        const svg = doc.documentElement;

        // Apply options like width, height, class, etc.
        if (options?.class) svg.setAttribute('class', options.class);
        if (options?.width) svg.setAttribute('width', options.width);
        if (options?.height) svg.setAttribute('height', options.height);

        return svg.outerHTML;
      },
    };
    
  }



}
